/* eslint-disable import/no-extraneous-dependencies */
import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from "../../utils/axiosInstance"

const url = process.env.BACKEND_URL;
const rsl_url = process.env.RSL_BACKEND_URL;
const support_url = process.env.RSL_ADMIN_SUPPORT_URL;
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  saveHotels: [],
  hotelCityList: [],  // Corrected: should be hotelCityList instead of cityListRes
  hotelList: [],
  hotelDetail: [],
  hotelBookingResponse: [],
  searchActivityRes: undefined,
  checkTimeRes: undefined,
  checkTimeResForPricing: undefined,
  activeIndex: 0,
};

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CITY LIST SUCCESS
    getLimousineFleetListSuccess(state, action) {
      state.isLoading = false;
      state.fleetsRes = action.payload;  // Corrected: update hotelCityList
    },
    getChaufferPlanListSuccess(state, action) {
      state.isLoading = false;
      state.chaufferPlanListRes = action.payload;  // Corrected: update hotelCityList
    },
    getChaufferPlanListSuccessNew(state, action) {
      state.isLoading = false;
      state.chaufferPlanListData = action.payload;  // Corrected: update hotelCityList
    },
    getChaufferPlanInfoSuccessNew(state, action) {
      state.isLoading = false;
      state.chaufferPlanInfoData = action.payload;  // Corrected: update hotelCityList
    },
    getInvestmentsListSuccess(state, action) {
      state.isLoading = false;
      state.investmentListRes = action.payload;  // Corrected: update hotelCityList
    },
    getLimousineFleetQuerySuccess(state, action) {
      state.isLoading = false;
      state.fleetsQueryRes = action.payload;  // Corrected: update hotelCityList
    },
    limousineInvestNowSuccess(state, action) {
      state.isLoading = false;
      state.investNowRes = action.payload;  // Corrected: update hotelCityList
    },
    carRentalInvestNowSuccess(state, action) {
      state.isLoading = false;
      state.carRentalEnquiryRes = action.payload;  // Corrected: update hotelCityList
    },
    tourInvestNowSuccess(state, action) {
      state.isLoading = false;
      state.tourEnquiryRes = action.payload;  // Corrected: update hotelCityList
    },
    ecommerceInvestNowSuccess(state, action) {
      state.isLoading = false;
      state.ecommerceEnquiryRes = action.payload;  // Corrected: update hotelCityList
    },
    commercialInvestNowSuccess(state, action) {
      state.isLoading = false;
      state.commercialEnquiryRes = action.payload;  // Corrected: update hotelCityList
    },
    getEcommerceListSuccess(state, action) {
      state.isLoading = false;
      state.ecommerceListRes = action.payload;  // Corrected: update hotelCityList
    },
    getInvestmentListSuccess(state, action) {
      state.isLoading = false;
      state.investmentListRes = action.payload;  // Corrected: update hotelCityList
    },
    getInvestmentAllListSuccess(state, action) {
      state.isLoading = false;
      state.investmentAllListRes = action.payload;  // Corrected: update hotelCityList
    },
    getEcommerceListQuerySuccess(state, action) {
      state.isLoading = false;
      state.ecommerceListQueryRes = action.payload;  // Corrected: update hotelCityList
    },
    getCommercialListQuerySuccess(state, action) {
      state.isLoading = false;
      state.commercialListQueryRes = action.payload;  // Corrected: update hotelCityList
    },
    getOverAllPriceListSuccess(state, action) {
      state.isLoading = false;
      state.overAllPriceRes = action.payload;  // Corrected: update hotelCityList
    },
    getOverAllAmountListSuccess(state, action) {
      state.isLoading = false;
      state.overAllAmountRes = action.payload;  // Corrected: update hotelCityList
    },
    getInvestmentEnquirySuccess(state, action) {
      state.isLoading = false;
      state.investEnquiryRes = action.payload;  // Corrected: update hotelCityList
    },
    getTourDatasSuccess(state, action) {
      state.isLoading = false;
      state.allTourRes = action.payload;  // Corrected: update hotelCityList
    },
    imageUploadSuccess(state, action) {
      state.isLoading = false;
      state.imageRes = action.payload;
    },
    getOwnershipTypeSuccess(state, action) {
      state.isLoading = false;
      state.ownershipTypeRes = action.payload;
    },
    clearImageRes(state) {
      state.imageRes = null;
      state.isLoading = false;
    },

  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  getLimousineFleetListSuccess,
  getLimousineFleetQuerySuccess,
  carRentalInvestNowSuccess,
  limousineInvestNowSuccess,
  getTourDatasSuccess,
  tourInvestNowSuccess,
  ecommerceInvestNowSuccess,
  commercialInvestNowSuccess,
  getEcommerceListSuccess,
  getInvestmentListSuccess, getInvestmentAllListSuccess, getChaufferPlanInfoSuccessNew, getInvestmentsListSuccess,
  getEcommerceListQuerySuccess,
  getCommercialListQuerySuccess,
  getOverAllPriceListSuccess,
  getOverAllAmountListSuccess,
  getInvestmentEnquirySuccess,
  imageUploadSuccess, getChaufferPlanListSuccessNew,
  getOwnershipTypeSuccess
} = slice.actions;

// ----------------------------------------------------------------------

// CAROUSEL REDUCER

export function carouselReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_ACTIVE_INDEX':
      return { ...state, activeIndex: action.payload }
    default:
      return state;
  }
}

// ----------------------------------------------------------------------

// GET CITY LIST FUNCTION

export function imageUpload(file) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(`${support_url}/document/uploadTempSingle`, file,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      dispatch(slice.actions.imageUploadSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.imageUploadSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function clearImageRes() {
  return (dispatch) => {
    dispatch(slice.actions.clearImageRes());
  };
}

export function getLimousineFleetList(url, ownershipType) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${rsl_url}/investment/${url}/list${ownershipType ? `?ownershipType=${ownershipType}` : ''}`);
      dispatch(slice.actions.getLimousineFleetListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getLimousineFleetListSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLimousineFleetQuery(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${rsl_url}/investment/${data?.url}/list?amount=${data?.amount}&currency=${data?.currency}${data?.ownershipType ? `&ownershipType=${data?.ownershipType}` : ''}`);
      dispatch(slice.actions.getLimousineFleetQuerySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getLimousineFleetQuerySuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function limousineInvestNow(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${rsl_url}/investment/limousine/enquiry`, data);
      dispatch(slice.actions.limousineInvestNowSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.limousineInvestNowSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function carRentalInvestNow(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${rsl_url}/investment/car/enquiry`, data);
      dispatch(slice.actions.carRentalInvestNowSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.carRentalInvestNowSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function tourInvestNow(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${rsl_url}/investment/travel-tourism/enquiry`, data);
      dispatch(slice.actions.tourInvestNowSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.tourInvestNowSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTourDatas() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${rsl_url}/investment/travel-tourism/list`);
      dispatch(slice.actions.getTourDatasSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getTourDatasSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function ecommerceInvestNow(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${rsl_url}/investment/ecommerce/enquiry`, data);
      dispatch(slice.actions.ecommerceInvestNowSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.ecommerceInvestNowSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEcommerceList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${rsl_url}/investment/ecommerce/list`);
      dispatch(slice.actions.getEcommerceListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getEcommerceListSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEcommerceListQuery(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${rsl_url}/investment/ecommerce/list?amount=${data?.amount}&currency=${data?.currency}`);
      dispatch(slice.actions.getEcommerceListQuerySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getEcommerceListQuerySuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function commercialInvestNow(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${rsl_url}/investment/commercial-broker/enquiry`, data);
      dispatch(slice.actions.commercialInvestNowSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.commercialInvestNowSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInvestmentList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${rsl_url}/investment/list?type=1`);
      dispatch(slice.actions.getInvestmentListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getInvestmentListSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInvestmentAllList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${rsl_url}/investment/list`);
      dispatch(slice.actions.getInvestmentAllListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getInvestmentAllListSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCommercialListQuery(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${rsl_url}/investment/commercial-broker/list`, data);
      dispatch(slice.actions.getCommercialListQuerySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getCommercialListQuerySuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getOverAllPriceList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${rsl_url}/investment/getOverAllPriceList`);
      dispatch(slice.actions.getOverAllPriceListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getOverAllPriceListSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getOverAllAmountList(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${rsl_url}/investment/getServicesList?amount=${data?.amount}&currency=${data?.currency}`);
      dispatch(slice.actions.getOverAllAmountListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getOverAllAmountListSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInvestmentEnquiry(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${rsl_url}/investment/enquiry`, data);
      dispatch(slice.actions.getInvestmentEnquirySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getInvestmentEnquirySuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getChaufferPlanList(url) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${rsl_url}/personalChauffeurPlan/list`);
      dispatch(slice.actions.getChaufferPlanListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getChaufferPlanListSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getChaufferPlanListNew(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${rsl_url}/personalChauffeurPlan/editPage?currency=usd`, obj);
      dispatch(slice.actions.getChaufferPlanListSuccessNew(response.data));
    } catch (error) {
      dispatch(slice.actions.getChaufferPlanListSuccessNew(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getChaufferPlanInfo(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${rsl_url}/personalChauffeurPlan/getPersonalChauffeurStatus`, obj);
      dispatch(slice.actions.getChaufferPlanInfoSuccessNew(response.data));
    } catch (error) {
      dispatch(slice.actions.getChaufferPlanInfoSuccessNew(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInvestmentsList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${rsl_url}/trip/getInvestmentServices`);
      dispatch(slice.actions.getInvestmentsListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getInvestmentsListSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getOwnershipType() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${rsl_url}/investment/limousine/ownerShipType`);
      dispatch(slice.actions.getOwnershipTypeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getOwnershipTypeSuccess(error?.response?.data ?? error));
      dispatch(slice.actions.hasError(error));
    }
  };
}